// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"22e8e788","110":"772e8908","129":"a592f9e5","196":"ca13e276","243":"0755fc2b","438":"365ce9cc","614":"73240c75","642":"eef6c125","756":"37875446","881":"70576f9d"}[chunkId] + ".chunk.js";
};